import Call from '../Call.v2';

const BidderWinRateSources = {
    get(source) {
        return Call(`bidder/winRate/factors/${source}`);
    }
};

export default BidderWinRateSources;


// WEBPACK FOOTER //
// ./src/services/API/components/BidderWinRateFactors.js